export default class Interp {

	constructor(pre, post, mid, stages, easing = x => x) {
		this._pre = pre;
		this._post = post;
		this._mid = mid;
		this._easing = easing;
		this._stages = stages.map(({
			begin,
			end,
			func = null,
			first = null,
			last = null,
			value = null
		}) => ({
			begin,
			end,
			func,
			first,
			last,
			value
		}));
	}

	get(x) {
		const stages = this._stages;
		if (x < stages[0].begin) {
			return this._pre;
		} else if (x > stages[stages.length - 1].end) {
			return this._post;
		}
		const stage = this._stages.filter(stage => stage.begin <= x && x <= stage.end)[0];
		if (!stage) {
			return this._mid;
		}
		const { begin, end, func, first, last, value } = stage;
		const i = this._easing((x - begin) / (end - begin));
		if (func !== null) {
			return func(i);
		} else if (value !== null) {
			return value;
		} else {
			return first + (last - first) * i;
		}
	}

}
